import {EnvironmentImageRequestParams} from "../../models/image/environment-image-request-params";

export class WelcomeImageRequestParams extends EnvironmentImageRequestParams {
  constructor() {
    super({});

    this._resourceName = `/background/Welcome`;
  }
}
